import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { GlobalService } from '../services/global.service';
import { ApiService } from '../services/api.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { ChangeDetectorRef } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { Observable, switchMap } from 'rxjs';

import { ModalController } from '@ionic/angular';
import { FormModalComponent } from '../components/form-modal/form-modal.component';
import { FormAddTextForModelInferencingComponent } from '../components/form-add-text-for-model-inferencing/form-add-text-for-model-inferencing.component';
import { ModelInferencingHistoryComponent } from '../components/model-inferencing-history/model-inferencing-history.component';



interface Metadata {
  remarks: string;
  usability: boolean;
  intonation:boolean;
  mispronounced_words: string;
  not_recorded_mispronounced_words: string;
  automation_passed: string;
  model_transcription:string;
  error_rate:Number;
  verified:boolean;
  text:string;
  

  
  // Add other metadata properties as needed
}


interface AudioData {
  audio_urls: string[];
  metadata: { [filename: string]: Metadata };
  page: number;
  page_size: number;
  total_pages: number;
  total_items: number;
}


@Component({
  selector: 'app-modelinferencing',
  templateUrl: './modelinferencing.page.html',
  styleUrls: ['./modelinferencing.page.scss'],
})
export class ModelinferencingPage implements OnInit {
  @ViewChild(IonContent, { static: false }) content!: IonContent;

  isEditing = false;
  editedRemarks: string = '';
  originalRemarks: string = '';
  isPopupOpen = false;
  item: any; // Replace with your actual type or interface.
  showFooter: boolean = false;
  audioData: AudioData | null = null;

  audioResponseList: string[] = [];
  textResponseList: string[] = [];
  toggleValue: boolean = false;
  modelList: string[] = [];  // To store the list of models from the API
  selectedModel: string = '';  // To store the selected model

  isReadOnly = true;
  @ViewChild('audioPlayer', { static: false }) audioPlayer!: ElementRef<HTMLAudioElement>;
  Audiopath:string = "";
  audioError: boolean = false;
  ttsForm !: FormGroup;
  
  

  formData = {
    message: '',
    lang: 'nl',
    model_name: ''
  };

  mispronouncedWordsValueToDisplay: string = '';
  notrecordedMispronounceWordsToDisplay:string = '';


  constructor(private modalCtrl: ModalController,private alertCtrl: AlertController,private cdRef: ChangeDetectorRef,private fb: FormBuilder,private http: HttpClient,private alertController: AlertController,private apiService:ApiService,private router:Router,private globalService:GlobalService) { }
  ionViewWillLeave() {
    console.log('localStorage from Model Inferencing Page cleared when leaving the page');
    // localStorage.setItem('notRemoveModelInferencingData', "true");
    
  }
  ngOnInit() {
    // localStorage.setItem('notRemoveModelInferencingData', "true");
    // this.getModelList();
    this.initializeForm();

    const lang = localStorage.getItem('selectedModelLanguageForTTS') || 'nl';
    const filter_value = 'all';
    const text_type = 'custom_text';
    const filter_usability_value = 'all';
    const filter_verified_value = 'all';
    localStorage.setItem('selectedFilterValueForTTS','all');
    localStorage.setItem('selectedUsabelFilterValueForTTS','all');
    localStorage.setItem('selectedVerifiedFilterValueForTTS','all');
    const model_name = localStorage.getItem('selectedModel');
    const formData = { lang, model_name,filter_value,text_type,filter_usability_value,filter_verified_value };
    const page = 1;
    this.retriveModelInferencingData(lang,model_name,formData,page)
  }


  async ionViewDidEnter(){
    // this.retriveModelInferencingData(lang,model_name,formData,page)
    
    const lang = localStorage.getItem('selectedModelLanguageForTTS') || 'nl';
    const text_type = localStorage.getItem('selectedTextFilterValueForTTS') || 'custom_text';
    const filter_value = localStorage.getItem('selectedFilterValueForTTS') || 'all';
    const filter_usability_value = localStorage.getItem('selectedUsabelFilterValueForTTS') || 'all';
    const filter_verified_value = localStorage.getItem('selectedVerifiedFilterValueForTTS') || 'all';
    const model_name = localStorage.getItem('selectedModel');
    // this.ttsForm.patchValue({ model_name: model_name });

    const formData = { lang, model_name,filter_value,text_type,filter_usability_value,filter_verified_value};
    const page = 1;
    if(!localStorage.getItem('notRemoveModelInferencingData')){
      this.retriveModelInferencingData(lang, model_name, formData, page);
    }
  }

  ionViewWillEnter() {
    // console.log('Entering Model Inferencing Page');
    
    // const lang = localStorage.getItem('selectedModelLanguageForTTS') || 'nl';
    // const model_name = localStorage.getItem('selectedModel');
    // const formData = { lang, model_name };
    // const page = 1;
    
    // this.retriveModelInferencingData(lang, model_name, formData, page);
    this.getModelList();
    this.initializeForm();
    // const m_name = localStorage.getItem('selectedModel');
    // this.ttsForm.patchValue({ model_name: m_name });
  }


  async retriveModelInferencingData(lang:any,modal_name:any,formData:any,page:any) {
    this.globalService.logoutLoading();
  
    
    this.apiService.generateSystemAudio(formData, page).subscribe(response => {
      if(response){
            console.log('All Model Inferenced Successfully:', response);

            this.audioData = response;
            this.audioResponseList = response.audio_urls;
            this.totalPages = response.total_pages;

            if (this.audioData) {
              if (response.metadata && typeof response.metadata === 'object') {
                this.audioData.metadata = response.metadata;
              } else {
                this.audioData.metadata = {}; // Prevent undefined issues
              }
            } else {
              console.error("audioData is null. Ensure it's initialized before using it.");
            }
            
            this.globalService.dismissLoading();
            setTimeout(() => {
              this.scrollToSection(); // Delay scrolling to ensure elements are loaded
            }, 300);
          }else {
            this.audioData = null;
            this.audioResponseList = [];
        }
        
      }, error => {
        this.audioData = null;
        this.audioResponseList = [];
        console.error('Model Inferenced error:', error);
        this.globalService.dismissLoading();
      });

  }
  


  // ionViewWillEnter() {
  //   this.getModelList();
  //   this.resetForm();
  // }
  resetForm() {
    const storedLang = localStorage.getItem('selectedModelLanguageForTTS') || 'nl';
    const selectedModel = localStorage.getItem('selectedModel') || 'nl';
    const f_v = localStorage.getItem('selectedFilterValueForTTS') || 'all';
    const f_v_usability = localStorage.getItem('selectedUsabelFilterValueForTTS') || 'all';
    const f_v_verified = localStorage.getItem('selectedVerifiedFilterValueForTTS') || 'all';
    const t_t = localStorage.getItem('selectedTextFilterValueForTTS') || 'custom_text';
    this.ttsForm.reset({
      message: '',
      lang: storedLang,  // You can set this to the default language
      model_name: selectedModel,  // Default to the first model if available
      filter_value: f_v,
      text_type: t_t,
      usability: [f_v_usability, [Validators.required]],
      verified: [f_v_verified, [Validators.required]],


    });

    this.Audiopath = "";
  }



  currentIndexOfPopup: number = -1;

  //adding the popup for model inferencing to add text
  async openFormModal(index: number,item:any) {
      
      this.currentIndexOfPopup =  index;
      console.log("CCCCurrnet index for Popup is:",this.currentIndexOfPopup);

      
      const modal = await this.modalCtrl.create({
        component: FormModalComponent,
        backdropDismiss: false,  // Prevent closing when clicking outside
        cssClass: 'large-modal', //custom class for styling
        componentProps:{
          'initiator':'modelinferencing',
          'urlId': this.audioData ? this.audioData['audio_urls'][this.currentIndexOfPopup] : null
        }
      });

      modal.onDidDismiss().then(async (datareturned)=>{
        if(datareturned && datareturned.data){
            let searchedText = datareturned.data.soundTextArray;
            let audioBlobs = datareturned.data.audioBlobs
            if(searchedText && searchedText.length > 0){
              let messages = searchedText.map((item:any)=>item.message).filter((item:any)=>!!item);
              this.mispronouncedWordsValueToDisplay = messages.join(', ');

              let noRecordedMispronouncedword = searchedText.map((item:any,index:any)=>{
                if(audioBlobs[index] instanceof Blob || item.audioFile instanceof File){
                  return null
                }else{
                  return item.message
                }

              }).filter((item:any)=>!!item);

              // let noRecordedMispronouncedword = searchedText
              //   .map((item:any, index:any) => (audioBlobs[index] instanceof Blob ?  null:  item.message))
              //   .filter((item:any): item is string => !!item)
              //   .join(", ");


              

              this.notrecordedMispronounceWordsToDisplay = noRecordedMispronouncedword.join(', ');

              const metadata = this.getMetadata(item);
              if (metadata) {
                // this.mispronouncedWordsValueToDisplay = metadata.mispronounced_words.trim() ? metadata.mispronounced_words + ',' + this.mispronouncedWordsValueToDisplay: this.mispronouncedWordsValueToDisplay;
                this.mispronouncedWordsValueToDisplay = metadata.mispronounced_words ? metadata.mispronounced_words + ',' + this.mispronouncedWordsValueToDisplay: this.mispronouncedWordsValueToDisplay;
                // this.notrecordedMispronounceWordsToDisplay = metadata.not_recorded_mispronounced_words.trim() ? metadata.not_recorded_mispronounced_words + (this.notrecordedMispronounceWordsToDisplay.trim()? ',':'') + this.notrecordedMispronounceWordsToDisplay :this.notrecordedMispronounceWordsToDisplay;
                this.notrecordedMispronounceWordsToDisplay = metadata.not_recorded_mispronounced_words ? metadata.not_recorded_mispronounced_words + (this.notrecordedMispronounceWordsToDisplay.trim()? ',':'') + this.notrecordedMispronounceWordsToDisplay :this.notrecordedMispronounceWordsToDisplay;
                metadata.mispronounced_words = this.mispronouncedWordsValueToDisplay;
                metadata.not_recorded_mispronounced_words =  this.notrecordedMispronounceWordsToDisplay;
              }

              // const url = this.audioData ? this.audioData['audio_urls'][this.currentIndexOfPopup] : null; // Use ternary operator for conditional assignment
              // console.log("UUUUUUUUUUUrl is:",url);


             
              if (item) {
                this.updateMispronouncedWordsAPI(this.mispronouncedWordsValueToDisplay, this.notrecordedMispronounceWordsToDisplay, item);
              } else {
                console.log("URL is invalid or missing.");
              }






            }
        }
      })
  
      await modal.present();
  
      // const { data } = await modal.onDidDismiss();
      // if (data) {
      //   console.log('Form Data:', data);
      // }
    }

  
  async openModelInferencingFormModal() {

        const modal = await this.modalCtrl.create({
          component: FormAddTextForModelInferencingComponent,
          backdropDismiss: false,  // Prevent closing when clicking outside
          cssClass: 'large-modal-1', //custom class for styling
          componentProps:{
            'initiator':'modelinferencing'
          }
        });
    
        await modal.present();
    
        const { data } = await modal.onDidDismiss();
        if (data) {
          console.log('Form Data:', data);
          const model_name = localStorage.getItem('selectedModel');
          const lang = localStorage.getItem('selectedModelLanguageForTTS');
          const filter_value = localStorage.getItem('selectedFilterValueForTTS') || 'all';
          const text_type = localStorage.getItem('selectedTextFilterValueForTTS') || 'custom_text';
          const filter_usability_value = localStorage.getItem('selectedUsabelFilterValueForTTS') || 'all';
          const filter_verified_value = localStorage.getItem('selectedVerifiedFilterValueForTTS') || 'all';
          const formData = { lang, model_name,filter_value,text_type,filter_usability_value,filter_verified_value };
          const page = 1;
          this.currentPage = 1;
          this.goToPageNumber = 1;
          try {
            await this.retriveModelInferencingData(lang, model_name, formData, page);
          } catch (error) {
              console.error("Error loading data:", error);
          } finally {
              modal.dismiss();
          }
        }
      }

  async openModelInferencingHistory(index: number,item:any,currentTextForHistory:string) {
  
    this.currentIndexOfPopup =  index;

    console.log("Index is:",index);
    console.log("Item is :",item);

    const modal = await this.modalCtrl.create({
      component: ModelInferencingHistoryComponent,
      backdropDismiss: false,  // Prevent closing when clicking outside
      cssClass: 'large-modal-2', //custom class for styling
      componentProps:{
        'initiator':'modelinferencing',
        'urlId': this.audioData ? this.audioData['audio_urls'][this.currentIndexOfPopup] : null,
        'currentTextForHistory':currentTextForHistory
      }
    });

    modal.onDidDismiss().then(async (datareturned)=>{
     
    })

    await modal.present();

    // const { data } = await modal.onDidDismiss();
    // if (data) {
    //   console.log('Form Data:', data);
    // }
  }
    

//   getModelList() {
//     const lang = localStorage.getItem('selectedModelLanguageForTTS') || 'nl';
//     this.apiService.getModelList(lang).subscribe(
//      (response) => {
//        console.log("response is:",response);
//        if (response && Array.isArray(response) && response.length > 0) {
//         this.modelList = response;  // Store the response in modelList
//         localStorage.setItem('selectedModel', response[0]);
//         this.ttsForm.patchValue({
//           model_name: response[0]
//         });

//       } else {
//         console.log('No data returned or an error occurred.');
//       }
//      },
//      (err) => {
//        console.log(err);
//      }
//    );
//  }


getModelList(): Promise<any[]> {
  return new Promise((resolve, reject) => {
    const lang = localStorage.getItem('selectedModelLanguageForTTS') || 'nl';
    this.apiService.getModelList(lang).subscribe(
      (response) => {
        console.log("response is:", response);
        if (response && Array.isArray(response) && response.length > 0) {
          this.modelList = response;
          localStorage.setItem('selectedModel', response[0]);
          this.ttsForm.patchValue({ model_name: response[0] });

          resolve(response[0]); // Resolve with the data
        } else {
          console.log('No data returned or an error occurred.');
          resolve([]); // Resolve with an empty array
        }
      },
      (err) => {
        console.log(err);
        reject(err); // Reject in case of an error
      }
    );
  });
}

 async onModelChange(event:any){
    const model_name = event.detail.value;
    localStorage.setItem('selectedModel', model_name);
    const filter_value = localStorage.getItem('selectedFilterValueForTTS') || 'all';
    const text_type = localStorage.getItem('selectedTextFilterValueForTTS') || 'custom_text';
    const filter_usability_value = localStorage.getItem('selectedUsabelFilterValueForTTS') || 'all';
    const filter_verified_value = localStorage.getItem('selectedVerifiedFilterValueForTTS') || 'all';
    const lang = localStorage.getItem('selectedModelLanguageForTTS') || 'nl';
    const formData = { lang, model_name,filter_value,text_type,filter_usability_value,filter_verified_value };
    const page = 1;
    this.currentPage = 1;
    this.goToPageNumber = 1;
    this.retriveModelInferencingData(lang,model_name,formData,page)

 }

 async onLanguageChange(event: any) {
    const lang = event.detail.value; 
    const filter_value = 'all';
    const text_type = 'custom_text';
    const filter_usability_value = 'all';
    const filter_verified_value = 'all';
    this.ttsForm.patchValue({ filter_value: filter_value });
    this.ttsForm.patchValue({ text_type: text_type });
    this.ttsForm.patchValue({ usability: filter_usability_value });
    this.ttsForm.patchValue({ verified: filter_verified_value });
    localStorage.setItem('selectedFilterValueForTTS', 'all');
    localStorage.setItem('selectedUsabelFilterValueForTTS', 'all');
    localStorage.setItem('selectedVerifiedFilterValueForTTS', 'all');
    localStorage.setItem('selectedModelLanguageForTTS', lang);
    this.getModelList().then((val) => {
      let model_name = val
      const formData = { lang, model_name,filter_value,text_type,filter_usability_value,filter_verified_value };
      const page = 1;
      this.currentPage = 1;
      this.goToPageNumber = 1;
      this.retriveModelInferencingData(lang,model_name,formData,page)

      console.log("Value received:", val);
    }).catch((error) => {
      console.error("Error fetching model list:", error);
    });
    
}


async onFilterValueChange(event: any) {
  const filter_value = event.detail.value; 
  const lang = localStorage.getItem('selectedModelLanguageForTTS') || 'nl';
  const filter_usability_value = localStorage.getItem('selectedUsabelFilterValueForTTS') || 'all';
  const filter_verified_value = localStorage.getItem('selectedVerifiedFilterValueForTTS') || 'all';
  const text_type = localStorage.getItem('selectedTextFilterValueForTTS') || 'custom_text';
  localStorage.setItem('selectedFilterValueForTTS', filter_value);
  const val = localStorage.getItem('selectedModel');
  let model_name = val
  const formData = { lang, model_name,filter_value,text_type,filter_usability_value,filter_verified_value };
  const page = 1;
  this.currentPage = 1;
  this.goToPageNumber = 1;
  this.retriveModelInferencingData(lang,model_name,formData,page)

  console.log("Value received:", val);
  
  
}

async onTextTypeValueChange(event: any) {
  const text_type = event.detail.value; 
  const lang = localStorage.getItem('selectedModelLanguageForTTS') || 'nl';
  const filter_value = localStorage.getItem('selectedFilterValueForTTS') || 'all';
  const filter_usability_value = localStorage.getItem('selectedUsabelFilterValueForTTS') || 'all';
  const filter_verified_value = localStorage.getItem('selectedVerifiedFilterValueForTTS') || 'all';
  localStorage.setItem('selectedTextFilterValueForTTS', text_type);
  const val = localStorage.getItem('selectedModel');
  let model_name = val
  const formData = { lang, model_name,filter_value,text_type,filter_usability_value,filter_verified_value };
  const page = 1;
  this.currentPage = 1;
  this.goToPageNumber = 1;
  this.retriveModelInferencingData(lang,model_name,formData,page)

  console.log("Value received:", val);
  
  
}

async onUsableFilterValueChange(event: any) {
  const filter_usability_value = event.detail.value; 
  const lang = localStorage.getItem('selectedModelLanguageForTTS') || 'nl';
  const filter_value = localStorage.getItem('selectedFilterValueForTTS') || 'all';
  const text_type = localStorage.getItem('selectedTextFilterValueForTTS') || 'custom_text';
  const filter_verified_value = localStorage.getItem('selectedVerifiedFilterValueForTTS') || 'all';
  localStorage.setItem('selectedUsabelFilterValueForTTS', filter_usability_value);
  const val = localStorage.getItem('selectedModel');
  let model_name = val
  const formData = { lang, model_name,filter_value,text_type,filter_usability_value,filter_verified_value };
  const page = 1;
  this.currentPage = 1;
  this.goToPageNumber = 1;
  this.retriveModelInferencingData(lang,model_name,formData,page)

  console.log("Value received:", val);
  
  
}
async onVerifiedFilterValueChange(event: any) {
  const filter_verified_value = event.detail.value; 
  const lang = localStorage.getItem('selectedModelLanguageForTTS') || 'nl';
  const filter_value  = localStorage.getItem('selectedFilterValueForTTS') || 'all';
  const text_type  = localStorage.getItem('selectedTextFilterValueForTTS') || 'custom_text';
  const filter_usability_value = localStorage.getItem('selectedUsabelFilterValueForTTS') || 'all';
  localStorage.setItem('selectedVerifiedFilterValueForTTS', filter_verified_value);
  const val = localStorage.getItem('selectedModel');
  let model_name = val
  const formData = { lang, model_name,filter_value,text_type,filter_usability_value,filter_verified_value };
  const page = 1;
  this.currentPage = 1;
  this.goToPageNumber = 1;
  this.retriveModelInferencingData(lang,model_name,formData,page)

  console.log("Value received:", val);
  
  
}



  
  initializeForm() {
    
    const storedLang = localStorage.getItem('selectedModelLanguageForTTS') || 'nl';
    const model_name = localStorage.getItem('selectedModel');
    const t_t = localStorage.getItem('selectedTextFilterValueForTTS') || 'custom_text';
    const f_v = localStorage.getItem('selectedFilterValueForTTS') || 'all';
    const f_v_usability = localStorage.getItem('selectedUsabelFilterValueForTTS') || 'all';
    const f_v_verified = localStorage.getItem('selectedVerifiedFilterValueForTTS') || 'all';
    this.ttsForm = this.fb.group({
      message: ['', [Validators.required]],    
      lang: [storedLang, [Validators.required]],   
      model_name: [model_name, [Validators.required]],
      filter_value: [f_v, [Validators.required]],
      text_type: [t_t, [Validators.required]],
      usability: [f_v_usability, [Validators.required]],
      verified: [f_v_verified, [Validators.required]],
      searchQuery: [''],
    });

    this.ttsForm.valueChanges.subscribe(() => {
      this.audioError = false;
    });
    
  }
  goToMenu() {
    this.router.navigate(['/menu']);
  }

  onSearch() {
    const query = this.ttsForm.get('searchQuery')?.value;
    if (query && query.trim() !== '') {
      console.log('Searching for:', query);
      // You can call your API or filter logic here
      // this.performSearch(query);

      const lang = localStorage.getItem('selectedModelLanguageForTTS');
      const model_name = localStorage.getItem('selectedModel');
      const filter_value = localStorage.getItem('selectedFilterValueForTTS');
      const filter_usability_value = localStorage.getItem('selectedUsabelFilterValueForTTS');
      const filter_verified_value = localStorage.getItem('selectedVerifiedFilterValueForTTS');
      const text_type = localStorage.getItem('textCategory');

      const searchQuery = query
      console.log("Search function is called",searchQuery);
      const formData = { lang, model_name,filter_value,text_type,filter_usability_value,filter_verified_value,searchQuery};
      const page = 1;
      this.currentPage = 1;
      this.goToPageNumber = 1;
      this.retriveModelInferencingData(lang,model_name,formData,page)

    }
  }

  clearSearch() {
    this.ttsForm.get('searchQuery')?.setValue('');
    // Optional: refresh your results list or reset filters
    const lang = localStorage.getItem('selectedModelLanguageForTTS');
    const model_name = localStorage.getItem('selectedModel');
    const filter_value = localStorage.getItem('selectedFilterValueForTTS');
    const filter_usability_value = localStorage.getItem('selectedUsabelFilterValueForTTS');
    const filter_verified_value = localStorage.getItem('selectedVerifiedFilterValueForTTS');
    const text_type = localStorage.getItem('textCategory');

    const searchQuery = '';
    console.log("Search function is called",searchQuery);
    const formData = { lang, model_name,filter_value,text_type,filter_usability_value,filter_verified_value,searchQuery};
    const page = 1;
    this.currentPage = 1;
    this.goToPageNumber = 1;
    this.retriveModelInferencingData(lang,model_name,formData,page)
  }

  onSearchInputChange(){
    const query = this.ttsForm.get('searchQuery')?.value;
    if (query === '') {
      // Make API call when input is cleared
      this.clearSearch();
    }
  }
  

  
  async confirmLogout() {
    // if(this.isRecording || this.hasUnsavedAudioData()){  
      const alert = await this.alertController.create({
            header: 'Confirm Logout',
            message: 'Are you sure you want to log out?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        // Do nothing when the user cancels
                    }
                },
                {
                    text: 'Logout',
                    handler: async () => {
                        // this.stopRecordingOnly();
                        await this.LogoutFunction();
                    }
                }
            ]
        });

        await alert.present();
      // }else{
      //   await this.LogoutFunction();
      // }
  }

  async LogoutFunction(){
  
      try{
          this.globalService.logoutLoading();
          const res:any = await this.apiService.logoutUser().toPromise();
              

          localStorage.removeItem('authenticationKey');
          localStorage.removeItem('accent');
          localStorage.removeItem('age');
          localStorage.removeItem('gender');
          localStorage.removeItem('userId');
          localStorage.removeItem('userName');
          localStorage.removeItem('language');

          localStorage.removeItem('searchedText');
          localStorage.removeItem('selectedModel');
          localStorage.removeItem('selectedModelLanguageForTTS');
          localStorage.removeItem('selectedFilterValueForTTS');
          
          localStorage.removeItem('selectedOptionUser');
          localStorage.removeItem('textCategory');
          localStorage.removeItem('totalCountData');
          localStorage.removeItem('usersList');
          localStorage.removeItem('userRole');
          

          localStorage.removeItem('notRemoveModelInferencingData');

          this.globalService.dismissLoading();
        
          this.router.navigate(['login']);



        
      
      }catch(error){
        console.log("Error:", error);
        // this.globalService.dismissLoading();
        this.router.navigate(['login']);

      }
      
  };
  




  scrollToSection() {
    setTimeout(() => {
      const target = document.getElementById('targetSection');
      if (target) {
        const yOffset = target.offsetTop;
        this.content.scrollToPoint(0, yOffset, 500);
      } else {
        console.warn("Target section not found!");
      }
    }, 300); // Delay ensures DOM updates before scrolling
  }

  
  urlChangeToText(url: string): string {
    const textMatch = url.match(/\/([^/]+)\.wav$/);
    return textMatch ? textMatch[1].replace(/_/g, ' ') : ''; // Replace underscores with spaces
  }
 urlChangeToText1(url: string): string {
    return url.substring(url.lastIndexOf('/') + 1);
  }

  updateAudioPath(newPath: string) {
    this.Audiopath = newPath;
    this.audioError == true?true:false;

    setTimeout(() => {
      if (this.audioPlayer && this.audioPlayer.nativeElement) {
        this.audioPlayer.nativeElement.load();
        // Listen for errors during audio playback
        this.audioPlayer.nativeElement.onerror = () => {
          this.audioError = true; // Set the error flag if there's an error loading the audio
        };
      }

    });
  }



  toggleUsability(url: string, event: any): void {
    const metadata = this.getMetadata(url);
    if (metadata) {
      metadata.usability = event.detail.checked; // Toggle usability based on ion-toggle state
      let filename = this.urlChangeToText1(url); // Set your file name
      const current_model_name: string = localStorage.getItem('selectedModel') || 'defaultModelName';


      let text_to_update = metadata.remarks;
      let intonation = metadata.intonation;
      let mispronounced_words = metadata.mispronounced_words;
      let not_recorded_mispronounced_words = metadata.not_recorded_mispronounced_words;
      let verified = metadata.verified;

  
      // Make API call
      this.globalService.logoutLoading(); // Show loading spinner or indicator
  
      this.apiService.updateMetaDataForModelInferencingData(filename,current_model_name, url,intonation, metadata.usability,text_to_update,mispronounced_words,not_recorded_mispronounced_words,verified)
        .subscribe(
          (response) => {
            console.log('Toggle button Update Successfully:', response);
            this.cdRef.detectChanges();
            this.globalService.dismissLoading(); // Dismiss loading spinner
          },
          (error) => {
            console.error('Toggle button Update error:', error);
            this.globalService.dismissLoading(); // Dismiss loading spinner on error
          }
        );
    }
  }


  toggleVerified(url: string, event: any): void {
    const metadata = this.getMetadata(url);
    if (metadata) {
      metadata.verified = event.detail.checked; // Toggle usability based on ion-toggle state
      let filename = this.urlChangeToText1(url); // Set your file name
      const current_model_name: string = localStorage.getItem('selectedModel') || 'defaultModelName';


      let text_to_update = metadata.remarks;
      let intonation = metadata.intonation;
      let mispronounced_words = metadata.mispronounced_words
      let not_recorded_mispronounced_words = metadata.not_recorded_mispronounced_words
      let usability = metadata.usability;


  
      // Make API call
      this.globalService.logoutLoading(); // Show loading spinner or indicator
  
      this.apiService.updateMetaDataForModelInferencingData(filename,current_model_name, url,intonation,usability,text_to_update,mispronounced_words,not_recorded_mispronounced_words,metadata.verified)
        .subscribe(
          (response) => {
            console.log('Toggle button Update Successfully:', response);
            this.cdRef.detectChanges();
            this.globalService.dismissLoading(); // Dismiss loading spinner
          },
          (error) => {
            console.error('Toggle button Update error:', error);
            this.globalService.dismissLoading(); // Dismiss loading spinner on error
          }
        );
    }
  }

  toggleIntonation(url: string, event: any): void {
    const metadata = this.getMetadata(url);
    if (metadata) {
      metadata.intonation = event.detail.checked; // Toggle usability based on ion-toggle state
      let filename = this.urlChangeToText1(url); // Set your file name
      const current_model_name: string = localStorage.getItem('selectedModel') || 'defaultModelName';


      let text_to_update = metadata.remarks;
      let usability = metadata.usability;
      let mispronounced_words = metadata.mispronounced_words;
      let not_recorded_mispronounced_words = metadata.not_recorded_mispronounced_words;
      let verified = metadata.verified;

  
      // Make API call
      this.globalService.logoutLoading(); // Show loading spinner or indicator
  
      this.apiService.updateMetaDataForModelInferencingData(filename,current_model_name, url, metadata.intonation,usability,text_to_update,mispronounced_words,not_recorded_mispronounced_words,verified)
        .subscribe(
          (response) => {
            console.log('Toggle button Update Successfully:', response);
            this.cdRef.detectChanges();
            this.globalService.dismissLoading(); // Dismiss loading spinner
          },
          (error) => {
            console.error('Toggle button Update error:', error);
            this.globalService.dismissLoading(); // Dismiss loading spinner on error
          }
        );
    }
  }

  async showAlert(oldRemarks:string,url:string) {
    const alert = await this.alertCtrl.create({
      header: 'Update Remarks',
      cssClass: 'custom-alert',
      inputs: [
        
        {
          name: 'newRemarks',
          type: 'text',
          value: oldRemarks,
          placeholder: 'Update remarks here !!!'
        }
        
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Update',
          handler: (data) => {
            console.log('User Input:', data);
            if (data.newRemarks) {
              this.updateRemarksAPI(oldRemarks, data.newRemarks,url);
            } else {
              console.log('New remarks cannot be empty');
              this.updateRemarksAPI(oldRemarks, " ",url);
            }
          }
        }
      ]
    });
  
    await alert.present();
  }
  

  updateRemarksAPI(oldRemarks: string, newRemarks: string, url: string){
    if(oldRemarks !== newRemarks){
      const metadata = this.getMetadata(url);
      if (metadata) {
        metadata.remarks = newRemarks;
      }
      const usability:any = metadata?.usability
      const verified:any = metadata?.verified
      const intonation:any = metadata?.intonation


      let filename = this.urlChangeToText1(url); // Set your file name
      const current_model_name: string = localStorage.getItem('selectedModel') || 'defaultModelName';


      let text_to_update = newRemarks;
      let mispronounced_words = metadata?.mispronounced_words ?? "";
      let not_recorded_mispronounced_words = metadata?.not_recorded_mispronounced_words ?? "";



  
      // Make API call
      this.globalService.logoutLoading(); // Show loading spinner or indicator
  
      this.apiService.updateMetaDataForModelInferencingData(filename,current_model_name, url,intonation, usability,text_to_update,mispronounced_words,not_recorded_mispronounced_words,verified)
        .subscribe(
          (response) => {
            this.cdRef.detectChanges();
            this.globalService.dismissLoading(); // Dismiss loading spinner
          },
          (error) => {
            console.error('Toggle button Update error:', error);
            this.globalService.dismissLoading(); // Dismiss loading spinner on error
          }
        );


      console.log("Make api call here");
    }
  }

  updateMispronouncedWordsAPI(newValueForMispronouncedWords: string, newValueForNotRecordedMispronouncedWords: string, url: string){
    
      const metadata = this.getMetadata(url);
      if (metadata) {
        let text_to_update = metadata.remarks;
        const usability:any = metadata?.usability
        const verified:any = metadata?.verified
        const intonation:any = metadata?.intonation


        let filename = this.urlChangeToText1(url); // Set your file name
        const current_model_name: string = localStorage.getItem('selectedModel') || 'defaultModelName';


        
        let mispronounced_words = newValueForMispronouncedWords
        let not_recorded_mispronounced_words = newValueForNotRecordedMispronouncedWords

  
        // Make API call
        // this.globalService.logoutLoading(); // Show loading spinner or indicator
    
        this.apiService.updateMetaDataForModelInferencingData(filename,current_model_name, url,intonation, usability,text_to_update,mispronounced_words,not_recorded_mispronounced_words,verified)
          .subscribe(
            (response) => {
              this.cdRef.detectChanges();
              // this.globalService.dismissLoading(); // Dismiss loading spinner
            },
            (error) => {
              console.error('Toggle button Update error:', error);
              // this.globalService.dismissLoading(); // Dismiss loading spinner on error
            }
          );

        }

    
  }


  openEditPopup(url: string,oldRemarks:any) {
    this.showAlert(oldRemarks,url)
  }

  

  getMetadata(url: string): Metadata | undefined {
    if (this.audioData) {
      const filename = url.split('/').pop() || ''; // Extract filename safely
      return this.audioData.metadata[filename];
    }
    return undefined;
  }

  // logic for pagination
  currentPage = 1;
  totalPages = 1;
  goToPageNumber: number | null = this.currentPage;


  goToPage(page: number) {
    try{
      const inputValue = Number(this.goToPageNumber);
      if (inputValue <= this.totalPages) {
        this.globalService.logoutLoading();
        if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
          this.goToPageNumber = page; // Keep them in sync
          // Add logic here to fetch/display data for the current page

          this.loadPageData(this.currentPage);
        
        }
      }
    }catch(error){
      console.log("Error:",error);
      this.globalService.dismissLoading();
    }
  }

  

  loadPageData(page: number) {
    console.log("This is the page number:", page);
    
    try {
      // this.globalService.logoutLoading();
      const lang = localStorage.getItem('selectedModelLanguageForTTS') || 'nl';
      const model_name = localStorage.getItem('selectedModel');
      const filter_value = localStorage.getItem('selectedFilterValueForTTS') || 'all';
      const text_type = localStorage.getItem('selectedTextFilterValueForTTS') || 'custom_text';
      const filter_usability_value = localStorage.getItem('selectedUsabelFilterValueForTTS') || 'all';
      const filter_verified_value = localStorage.getItem('selectedVerifiedFilterValueForTTS') || 'all';
      const formData = { lang, model_name,filter_value,text_type,filter_usability_value,filter_verified_value };
      this.retriveModelInferencingData(lang,model_name,formData,page)
      // this.globalService.dismissLoading();
      
      // if (this.ttsForm.valid) {
      //   const formData = this.ttsForm.getRawValue();
        
      //   this.apiService.generateSystemAudio(formData, page).subscribe(response => {
      //     console.log('All Model Inferenced Successfully:', response);
          
      //     this.audioResponseList = response.audio_urls;
      //     this.totalPages = response.total_pages;
          
          
      //     if (this.audioData) {
      //       if (response.metadata && typeof response.metadata === 'object') {
      //         this.audioData.metadata = response.metadata;
      //       } else {
      //         this.audioData.metadata = {}; // Prevent undefined issues
      //       }
      //     } else {
      //       console.error("audioData is null. Ensure it's initialized before using it.");
      //     }
          
  
      //     this.scrollToSection();
      //     this.globalService.dismissLoading();
          
      //   }, error => {
      //     console.error('Model Inferenced error:', error);
      //     this.globalService.dismissLoading();
      //   });
      // }
    } catch (error) {
      console.log('Form is invalid');
      this.globalService.dismissLoading();
    }
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.goToSpecificPage();
    }
  }

  goToSpecificPage() {
    if (this.goToPageNumber) {
      this.goToPage(this.goToPageNumber);
    }
  }

  isButtonDisabled: Map<number, boolean> = new Map();
  checkInput(inputElement: HTMLInputElement, index: number) {
    // Enable button if input field has a value, otherwise disable it.
    this.isButtonDisabled.set(index, !inputElement.value.trim());
  }

  isDisabledSingle: boolean = true;
  checkInput1(value: string) {
    // Enable button if input field has a value, otherwise disable it.
    this.isDisabledSingle = value.trim() === '';
  }


  postMispronounced(item: string, inputElement: HTMLInputElement,parentIndex: number) {
    
    let mispronouncedWords = inputElement.value;

    if (mispronouncedWords) {
      // Split the text into a list by commas
      const wordsList = mispronouncedWords.split(',').map(word => word.trim());
  
      // Log each word one by one
      wordsList.forEach((word, index) => {
        console.log(`Word ${index + 1}: ${word}`);
        const jsonData = {  // Create a JSON object for each word
            message: word,
            lang: 'nl',
            type: 'text'
        };
        // const jsonData = {  // Create a JSON object for each word
        //     message: word,
        //     lang: 'english',
        //     type: 'text'
        // };

        try{
          this.globalService.logoutLoading();
          
          this.apiService.addText(jsonData).subscribe(response => {
            console.log('Text added successfully!!!', response);  
            
            

          }, error => {
            console.error('Adding Text error:', error);
          });
          this.globalService.dismissLoading();
        }catch(error){
          console.log('Form is invalid');
        }
      });


      inputElement.value = '';  // Clear the input field
      this.isButtonDisabled.set(parentIndex, true);  // Disable button again
      this.isDisabledSingle = true;
      
      this.showAlertOfPost(mispronouncedWords); 
      
  
    } else {
      console.log('Input is empty.');
    }
    

    console.log("Mispronounced Word is:",mispronouncedWords)
    }


  wordsList(wordsList: any) {
    throw new Error('Method not implemented.');
  }


  async showAlertOfPost(wordsList: any) { // Type wordsList as an array of strings
    const alert = await this.alertController.create({
        header: 'Added Texts are:',
        cssClass: 'custom-alert',
        message: wordsList, // Use a function to format the list
        buttons: ['OK'] // Add an OK button to close the alert
    });

    await alert.present();
  }

  

  

}
